module.exports = __webpack_public_path__ + "static/rendering1-fc4908629a82fadf46be9323be1ed0b3.png";